import { FC, memo, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { GradientWrapper, Chevron } from './telegram.styled';
import { Text, Button } from '../../components-v4';
import { ReactComponent as TelegramIcon } from '../../assets/Telegram-icon.svg';
import { BannerSkeleton } from '../skeletons';
import { getOnLoadPublicRequestState } from '../../selectors';
import { MIN_SKELETON_DURATION } from '../../constants';

type Props = {
  inHeader?: boolean;
};

export const Telegram: FC<Props> = memo(({ inHeader }) => {
  const onLoadRequest = useSelector(getOnLoadPublicRequestState);
  const [showSkeleton, setShowSkeleton] = useState<boolean>(onLoadRequest);
  const loadStartRef = useRef<number | null>(onLoadRequest ? Date.now() : null);

  useEffect(() => {
    if (onLoadRequest) {
      loadStartRef.current = Date.now();
      setShowSkeleton(true);
    } else if (loadStartRef.current !== null) {
      const elapsed = Date.now() - loadStartRef.current;
      const remaining = MIN_SKELETON_DURATION - elapsed;

      if (remaining > 0) {
        const timer = setTimeout(() => setShowSkeleton(false), remaining);
        return () => clearTimeout(timer);
      }

      setShowSkeleton(false);
    }
  }, [onLoadRequest]);

  const handleGo = () => {
    const link = document.createElement('a');
    link.href = `https://t.me/arseniy_kabinet_bot/`;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.click();
  };

  if (inHeader) {
    return (
      <Button
        mode="accent"
        variant="ghost"
        size="s"
        onClick={handleGo}
        leftIcon={<TelegramIcon />}
      >
        Telegram-бот
      </Button>
    );
  }

  if (showSkeleton) {
    return (
      <div>
        <BannerSkeleton />
      </div>
    );
  }

  return (
    <GradientWrapper onClick={handleGo}>
      <Text variant="body-16" color="white">
        Чат-бот «Арсений» в Telegram
      </Text>
      <Chevron />
    </GradientWrapper>
  );
});
